import {useDispatch} from 'react-redux';
import {PagesInterface, TokenInfoPagePayload} from './legacyModalsTypes';
import {legacyModalsApi} from './modalsActions';
import {Modals} from './modalsApi';

export function useModalsToggler(page: keyof PagesInterface) {
    const dispatch = useDispatch();

    const changeFlag = (modal: string) => {
        dispatch(legacyModalsApi.toggle(page, modal));
    };

    const closeModals = () => dispatch(Modals.clear());

    return {changeFlag, closeModals};
}

export const modalsTogglerClassDispatcher = (page: keyof PagesInterface) => (modal: TokenInfoPagePayload) => {
    return legacyModalsApi.toggle(page, modal);
};

export const closeAllLegacyModals = () => Modals.clear();
